import { Link, NavLink } from 'react-router-dom'
import './index.scss'
import LogoS from '../../assets/images/logo-s.png'
import LogoSubtittle from '../../assets/images/logo_sub.png'
import  { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope,  faHome, faUser } from '@fortawesome/free-solid-svg-icons'
import{ faArtstation, faGithub,  faLinkedinIn, faYoutube } from '@fortawesome/free-brands-svg-icons'


const Sidebar = () => (

    <div className="nav-bar">
        <Link className="logo" to="/">
            <img src={LogoS} alt="logo" />
            <img className="sub-logo" src={LogoSubtittle} alt="darkdan" />
        </Link>
        <nav>
            <NavLink exact="true" activecslassname="active" to="/">
                <FontAwesomeIcon icon={faHome} color="#4d4d4e" /></NavLink>
            <NavLink exact="true" activecslassname="active"  className="about-link" to="/about">
                <FontAwesomeIcon icon={faUser} color="#4d4d4e" /></NavLink>
            <NavLink exact="true" activecslassname="active" className="contact-link" to="/contact">
                <FontAwesomeIcon icon={faEnvelope} color="#4d4d4e" />
            </NavLink>
        </nav>
        <ul>
            <li>
                <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/daniel-le%C3%B3n-804ab063/">
                    <FontAwesomeIcon icon={ faLinkedinIn } color="#4d4d4e" />
                </a>
            </li>
            <li>
                <a target="_blank" rel="noreferrer" href="https://github.com/Darkyxz/">
                    <FontAwesomeIcon icon={ faGithub } color="#4d4d4e" />
                </a>
            </li>
            <li>
                <a target="_blank" rel="noreferrer" href="https://www.youtube.com/channel/UC6kC533pjmNU8Q7DsuSTpxg/">
                    <FontAwesomeIcon icon={ faYoutube } color="#4d4d4e" />
                </a>
            </li>
            <li>
                <a target="_blank" rel="noreferrer" href="https://d4rkd4n.artstation.com/">
                    <FontAwesomeIcon icon={ faArtstation } color="#4d4d4e" />
                </a>
            </li>

        </ul>

    </div>
    )

export default Sidebar;